import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    path: '/transporte/trarelatoriomapaviagens',
    name: 'trarelatoriomapaviagens',
    description: 'Mapa de Viagens',
    component: () => import('@/views/transporte/trarelatoriomapaviagens/Configuracao.vue'),
    meta: { permissions: [eTipoPermissao.MAPADEVIAGENSNOVO_MENU_1100200699] },
    goesToMenu: true,
  },
];
